import { TouchList } from 'react';

import { Point2D } from './types';

export function getDistance(p1: Point2D, p2: Point2D) {
    return Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
}

export function getAngle(p0: Point2D, p1: Point2D, p2: Point2D) {
    const abx = p0.x - p1.x;
    const aby = p0.y - p1.y;
    const bcx = p2.x - p1.x;
    const bcy = p2.y - p1.y;
    const t = (abx * bcx + aby * bcy) / Math.sqrt((abx ** 2 + aby ** 2) * (bcx ** 2 + bcy ** 2));
    return (Math.acos(t) * 180) / Math.PI;
}

export function getDeviation1(value: number) {
    const diff = 6;
    return [value + diff, value - diff];
}

export function getDeviation2(value: number) {
    const diff = 0.2;
    return [value + diff, value - diff];
}

export function getPoints(touches: TouchList) {
    const points: Point2D[] = [];
    for (let i = 0; i < touches.length; i += 1) {
        const touch = touches.item(i)!;
        const newPoint: Point2D = {
            x: touch.screenX,
            y: touch.screenY,
        };
        let count = 0;
        for (const comp of points) {
            const distance = getDistance(comp, newPoint);
            if (distance < 30) {
                count += 1;
                break;
            }
        }
        if (count === 0) {
            points.push(newPoint);
        }
    }
    return points;
}
